var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "navIcon",
    stroke: "currentColor",
    strokeLinecap: "square",
    d: "M5 9L1.5 5.5M5.5 9.5l4-4M9.5 5.5l7-4",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "navIcon",
    cx: 5.5,
    cy: 9.5,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "navIcon",
    cx: 9.5,
    cy: 5.5,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "navIcon",
    cx: 16.5,
    cy: 1.5,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "navIconStroke",
    cx: 7.5,
    cy: 7.5,
    r: 6.5,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "navIconStroke",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 13l4.5 4.5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconData);
export default __webpack_public_path__ + "static/media/icon-data.33e0429d13a5b650e3fec40ecbe9aee3.svg";
export { ForwardRef as ReactComponent };